var _path, _mask, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCheckBallInactive = function SvgCheckBallInactive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "check_ball-inactive_svg__a",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M2 8a6 6 0 1 1 12 0A6 6 0 0 1 2 8Z",
    clipRule: "evenodd"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#87AACA",
    d: "M8 1a7 7 0 0 0-7 7h2a5 5 0 0 1 5-5V1Zm7 7a7 7 0 0 0-7-7v2a5 5 0 0 1 5 5h2Zm-7 7a7 7 0 0 0 7-7h-2a5 5 0 0 1-5 5v2ZM1 8a7 7 0 0 0 7 7v-2a5 5 0 0 1-5-5H1Z",
    mask: "url(#check_ball-inactive_svg__a)"
  })));
};
export default SvgCheckBallInactive;